import { Scenario, YEARS_AHEAD } from 'spw-redux/modules/calculators/types';
import _ from 'lodash';
import { GROWTH_CALCULATORS } from 'spw-constants';
import { calculateGrowthEntries, getYearHeadcount } from './utils';
import ProgramScenario, { PlainProgramScenario } from './Scenario';

export default class HeadcountScenario extends ProgramScenario {
  constructor(apiScenario: Scenario) {
    const { department } = apiScenario;

    const { headcountSeatCountGrowthRate } = apiScenario;

    const growthEntries = calculateGrowthEntries({
      startYear: apiScenario.startYear,
      growthYears: apiScenario.growthYears,
      headcountSeatCountBase: apiScenario.headcountSeatCountBase,
      headcountSeatCountGrowthRate,
      growths: apiScenario.growths,
    });

    const headcount =
      apiScenario.targetYear === apiScenario.startYear
        ? apiScenario.headcountSeatCountBase
        : getYearHeadcount(apiScenario.targetYear, growthEntries);

    super(headcount, apiScenario);

    this.growths = [
      {
        growthEntries,
        headcountSeatCountGrowthRate: apiScenario.headcountSeatCountGrowthRate,
        headcountSeatCountBase: apiScenario.headcountSeatCountBase,
        department,
        aggregation: !department,
      },
    ];
    this.growthPercentage = headcountSeatCountGrowthRate;
  }

  static parseToHeadcountScenario = (scenario: PlainProgramScenario) => {
    const newScenario = _.cloneDeep(scenario);
    newScenario.department = null;
    newScenario.floorId = null;
    if (scenario.calculatorType === GROWTH_CALCULATORS.macroProgramming) {
      newScenario.headcountSeatCountBase = scenario.headcount;
      newScenario.headcountSeatCountGrowthRate = 0;
      newScenario.targetYear = scenario.startYear;
      newScenario.endYear = scenario.startYear + YEARS_AHEAD;
      newScenario.vacancyFactorPercentage = 0;
      newScenario.isShared = false;
    }
    newScenario.base = null;

    return newScenario;
  };
}
